type RevenueIntelligenceSessionResult = {
  data: {
    session: {
      access_token?: string;
    } | null;
  };
  error?: unknown;
};

export const REVENUE_INTELLIGENCE_SESSION_TIMEOUT_MS = 5_000;

export async function getRevenueIntelligenceChatAccessToken(
  getSession: () => PromiseLike<RevenueIntelligenceSessionResult>,
  timeoutMs = REVENUE_INTELLIGENCE_SESSION_TIMEOUT_MS,
): Promise<string | null> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error("Revenue Intelligence chat session timed out"));
    }, timeoutMs);
  });

  try {
    const result = await Promise.race([
      Promise.resolve(getSession()),
      timeout,
    ]);
    if (result.error) throw result.error;
    return result.data.session?.access_token ?? null;
  } finally {
    if (timeoutId !== null) clearTimeout(timeoutId);
  }
}
